var map = {
	"./DSC_0213.jpg": 3321,
	"./IMG_0267.jpg": 837,
	"./IMG_0282.jpg": 9538,
	"./IMG_0285.jpg": 5025,
	"./IMG_7539.png": 3886
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7283;